import { useState, useRef, useCallback } from "react";
import useEffect from "react";
import ImageGallery from "react-image-gallery";
import React from "react";
import "./gallery.css";

const Gallery = ({ galleryData,media_order }) => {
  const [infinite, setInfinite] = useState(true);
  const [showBullets, setShowBullets] = useState(true);
  const [showFullscreenButton, setShowFullscreenButton] = useState(true);
  const [showPlayButton, setShowPlayButton] = useState(true);
  const [showThumbnails, setShowThumbnails] = useState(true);
  const [showIndex, setShowIndex] = useState(true);
  const [showNav, setShowNav] = useState(true);
  const [isRTL, setIsRTL] = useState(true);
  const [thumbnailPosition, setThumbnailPosition] = useState("left");
  const [thumbnailPosition2, setThumbnailPosition2] = useState("left");
  const [slideDuration, setSlideDuration] = useState(450);
  const [slideInterval, setSlideInterval] = useState(1000);
  const [slideOnThumbnailOver, setSlideOnThumbnailOver] = useState(true);
  const [useWindowKeyDown, setUseWindowKeyDown] = useState(true);
  const [showGalleryFullscreenButton, setShowGalleryFullscreenButton] =
    useState(true);
  const [showGalleryPlayButton, setShowGalleryPlayButton] = useState(true);
  const imageGalleryRef = useRef(null);
  //   const [isMobile, setIsMobile] = useState(false)

  if (media_order.length > 0) {
    galleryData.sort((a, b) => {
      const indexA = media_order.indexOf(a.media.id);
      const indexB = media_order.indexOf(b.media.id);
      return indexA - indexB;
    });
  }
  let images;
  images = galleryData.map((item, i) => {
    const temp = {
      original: item.media.file,
      thumbnail: item.media.file,
      fullscreen: item.media.file,
      originalHeight: 600,
      thumbnailHeight: 150,
      originalWidth: 1000,
      thumbnailWidth: 250,
    };
    return temp;
  });

 
  const handleImageClick = (event) => {
    // handle image click event
  };

  const handleImageLoad = (event) => {
    // handle image load event
  };

  const handleSlide = (currentIndex) => {
    // handle slide event
  };

  const handlePause = (currentIndex) => {
    // handle pause event
  };

  const handleScreenChange = (isFullscreen) => {
    // handle screen change event
  };

  const handlePlay = (currentIndex) => {
    // handle play event
  };
  const renderItem = useCallback((item) => {
    const onImageError = (event) => {
      if (item && item.onErrorImageURL) {
        event.target.src = item.onErrorImageURL;
      }
    };

    return (
      <div className="image-gallery-image">
        <img
          src={item.original}
          alt={item.originalAlt}
          title={item.originalTitle}
          onError={onImageError}
          className={
            imageGalleryRef.current && imageGalleryRef.current.isFullscreen()
              ? "fullscreen"
              : ""
          }
        />
        {item.description && (
          <span className="image-gallery-description">{item.description}</span>
        )}
      </div>
    );
  }, []);
  return (
    <div>
      <div className="flex sm:hidden">
        <ImageGallery
          ref={imageGalleryRef}
          items={images}
          //   onClick={handleImageClick}
          //   onImageLoad={handleImageLoad}
          //   onSlide={handleSlide}
          //   onPause={handlePause}
          //   onScreenChange={handleScreenChange}
          //   onPlay={handlePlay}
          //   infinite={infinite}
          //   showBullets={showBullets}
          //   showFullscreenButton={showFullscreenButton && showGalleryFullscreenButton}
          //   showPlayButton={showPlayButton && showGalleryPlayButton}
          //   showThumbnails={showThumbnails}
          //   showIndex={showIndex}
          //   showNav={showNav}
          //   isRTL={isRTL}
          thumbnailPosition={thumbnailPosition2}
          //   slideDuration={slideDuration}
          //   slideInterval={slideInterval}
          slideOnThumbnailOver={slideOnThumbnailOver}

          //   useWindowKeyDown={useWindowKeyDown}
        />
      </div>
      <div className="hidden sm:flex">
        <ImageGallery
          ref={imageGalleryRef}
          items={images}
          //   onClick={handleImageClick}
          //   onImageLoad={handleImageLoad}
          //   onSlide={handleSlide}
          //   onPause={handlePause}
          //   onScreenChange={handleScreenChange}
          //   onPlay={handlePlay}
          //   infinite={infinite}
          //   showBullets={showBullets}
          //   showFullscreenButton={showFullscreenButton && showGalleryFullscreenButton}
          //   showPlayButton={showPlayButton && showGalleryPlayButton}
          //   showThumbnails={showThumbnails}
          //   showIndex={showIndex}
          //   showNav={showNav}
          //   isRTL={isRTL}
          thumbnailPosition={thumbnailPosition}
          //   slideDuration={slideDuration}
          //   slideInterval={slideInterval}
          slideOnThumbnailOver={slideOnThumbnailOver}

          //   useWindowKeyDown={useWindowKeyDown}
        />
      </div>
    </div>
  );
};

export default Gallery;
